module.exports = __webpack_public_path__ + "img/tempo-logo-new-blue.e4b2b7c9.png";